(function () {
  'use strict';

  /**
   * @ngdoc filter
   * @name oqs.filter:trustAsHtml
   *
   * @description
   *
   * @param {String} input The string to filter
   * @returns {Object} The trusted object
   *
   */
  angular
    .module('oqs')
    .filter('trustAsHtml', trustAsHtml);

  function trustAsHtml($sce) {
    return function (input) {
      return $sce.trustAsHtml(input);
    };
  }
}());
